export namespace ApiEndpoint {
  export enum UserInfo {
    GET_ALL = "/api/users",
    GET_USR_INFO = "/api/users/info/:id",
    GET_USR_INFO_BY_USERNAME = "/api/users/username/:username",
    CREATE_USR_INFO = "/api/users/create",
    UPDATE_USR_INFO = "/api/users/update/:id",
    DELETE_USR_INFO = "/api/users/delete/:id",
    GET_AD_USER_INFO_ALL = "api/users/ad-user/all",
    CREATE_USERS = "api/users/create-users",
  }

  export const Gereral = {
    GET_ALL_DPM: "api/data/department/all",
    GET_DPM_EMP: "api/data/department/{code}/employee-list",
    GET_ALL_EMP: "api/data/department/employee/list",
    GET_USERS: "api/data/external-department/users/all",
    GET_END_REASONS: "api/data/reason-end/all",
  };

  export const AdminFlightInfo = {
    PATH: "api/admin/flight-info",
  };

  export const AdminUserInfo = {
    SEARCH: "api/admin/data/external-users/search",
    GET_ALL: "api/admin/data/external-users/all",
    CREATE: "api/admin/data/external-users/create",
    GET_BY_ID: "api/admin/data/external-users/{id}",
    UPDATE: "api/admin/data/external-users/{id}",
    UPDATE_STATUS: "api/admin/data/external-users/{id}/update-status",
    RESET_PWD: "api/admin/data/external-users/reset-password",
  };

  export const AdminComplaintTopic = {
    SEARCH: "api/admin/complaint/main-topic/search",
    GET_ALL_MAIN: "api/admin/complaint/main-topic/all",
    CREATE_MAIN: "api/admin/complaint/main-topic/create",
    UPDATE_MAIN: "api/admin/complaint/main-topic/{id}",
    UPDATE_STATUS_MAIN: "api/admin/complaint/main-topic/{id}/update-status",
    ORDER_MAIN: "api/admin/complaint/main-topic/change-sort-number",
    CREATE_SUB: "api/admin/complaint/sub-topic/{mainId}/create",
    UPDATE_SUB: "api/admin/complaint/sub-topic/{id}",
    UPDATE_STATUS_SUB: "api/admin/complaint/sub-topic/{id}/update-status",
    ORDER_SUB: "api/admin/complaint/sub-topic/change-sort-number",
  };

  export const AdminForm = {
    GET_ALL: "api/admin/form/all",
    SEARCH: "api/admin/form/search",
    GET_BY_ID: "api/admin/form/{id}",
    UPDATE: "api/admin/form/{id}",
    CREATE: "api/admin/form/create",
    UPDATE_STATUS: "api/admin/form/{id}/update-status",
    GET_ALL_STEPS: "api/admin/form/steps",
  };

  export const AdminTicketChannel = {
    SEARCH: "api/admin/ticket-channel/search",
    GET_ALL_MAIN: "api/admin/ticket-channel/all",
    CREATE_MAIN: "api/admin/ticket-channel/main/create",
    UPDATE_MAIN: "api/admin/ticket-channel/main/{id}",
    UPDATE_STATUS_MAIN: "api/admin/ticket-channel/main/{id}/update-status",
    ORDER_MAIN: "api/admin/ticket-channel/main/change-sort-number",
    CREATE_SUB: "api/admin/ticket-channel/sub/{mainId}/create",
    UPDATE_SUB: "api/admin/ticket-channel/sub/{id}",
    UPDATE_STATUS_SUB: "api/admin/ticket-channel/sub/{id}/update-status",
    ORDER_SUB: "api/admin/ticket-channel/sub/change-sort-number",
  };

  export const AdminResponsiblePerson = {
    SEARCH: "api/admin/responsible-person/search",
    GET_ALL: "api/admin/responsible-person/all",
    CREATE: "api/admin/responsible-person/create",
    UPDATE: "api/admin/responsible-person/{departmentCode}",
    UPDATE_STATUS:
      "api/admin/responsible-person/{departmentCode}/update-status",
  };

  export const ComplaintTopic = {
    GET_ALL_MAIN: "api/data/complaint/main-topic/all",
    GET_MAIN_BY_ID: "api/data/complaint/main-topic/{id}",
    GET_ALL_SUB: "api/data/complaint/sub-topic/{mainId}/all",
    GET_SUB_BY_ID: "api/data/complaint/sub-topic/{id}",
  };

  export const Complaint = {
    SEARCH: "api/dept/transaction-status/search",
    GET_ALL: "api/dept/transaction-status/all",
    ASSIGN_DPM: "api/dept/transaction/{requestNo}/assign-department",
    REQ_DOC: "api/dept/transaction/{requestNo}/request-additional-doc",
    CONSIDER_DOC: "api/dept/transaction/{requestNo}/consider-additional-doc",
    SUMMARY_SAVE: "api/dept/transaction/{requestNo}/summary-save",
    END: "api/dept/transaction/{requestNo}/end",
    SUMMARY: "api/dept/transaction/{requestNo}/summary-results",
    SUMMARY_TO_MAIN: "api/dept/transaction/{requestNo}/summary-to-main-resp",
    SEND_ASC: "api/dept/transaction/{requestNo}/return-results",
    SEND_AIRLINE: "api/dept/transaction/{requestNo}/send-to-external-dept",
    UPDATE_PERSON: "api/dept/transaction/{requestNo}/change-responsible-person",
    AIRLINE_SAVE: "api/dept/transaction/{requestNo}/external-dept/save",
    AIRLINE_SUBMIT: "api/dept/transaction/{requestNo}/external-dept/submit",
    AIRLINE_RETURN: "api/dept/transaction/{requestNo}/external-dept/return",
    SAVE_CHAT: "api/dept/transaction/{requestNo}/chat/save",
    READ_CHAT: "api/dept/transaction/{requestNo}/read-chat",
    EXPORT_EXCEL: "api/dept/transaction/export-excel",
    EXPORT_PDF: "api/dept/transaction/{lang}/{requestNo}/export-pdf",
    READ_OPM: "api/dept/transaction/{requestNo}/read-opm",
  };

  export const UserComplaint = {
    SEARCH: "api/data/transaction-status/search",
    GET_ALL: "api/data/transaction-status/all",
    GET_BY_REQNO: "api/data/transaction/{requestNo}/get",
    CREATE_REQ: "api/data/transaction/create",
    SAVE_REQ: "api/data/transaction/{requestNo}/save",
    SUBMIT_REQ: "api/data/transaction/submit",
    SAVE_DOC: "api/data/transaction/{requestNo}/save-additional-doc",
    CANCEL: "api/data/transaction/{requestNo}/cancel",
    END: "api/data/transaction/{requestNo}/end",
    APPEAL: "api/data/transaction/{requestNo}/appeal",
  };

  export const OcpbComplaint = {
    GET_ALL: "api/ocpb/transaction-status/all",
    GET_DETAIL: "/api/data/ocpb/{code}",
    SEARCH: "api/ocpb/transaction-status/search",
    CREATE: "api/ocpb/transaction/create",
    GET_ATTACH: "api/data/ocpb/attachments",
    RETURN: "api/dept/transaction/{requestNo}/return-ocpb-results",
  };

  export const OpmComplaint = {
    GET_ALL: "api/opm/transaction-status/all",
    GET_DETAIL: "api/data/opm/{code}",
    GET_COMPLAINANT: "api/data/opm/{customerId}/get-complaintant-info",
    SEARCH: "api/opm/transaction-status/search",
    CREATE: "api/opm/transaction/create",
    GET_ATTACH: "api/data/opm/{caseId}/attachments",
    DOWNLOAD: "api/data/opm/{attachmentId}/download",
    RETURN: "api/dept/transaction/{requestNo}/return-opm-results",
    GET_OPERATING: "api/data/opm/{caseId}/get-operatings",
    SAVE_OPERATING: "api/dept/transaction/{caseId}/save-operating",
    SAVE_ATTACH: "api/data/opm/{caseId}/upload",
  };

  export const TicketChannel = {
    GET_ALL_MAIN: "api/data/ticket-channel/all",
    GET_MAIN_BY_ID: "api/data/ticket-channel/main/{id}",
    GET_ALL_SUB: "api/data/ticket-channel/sub/{mainId}/all",
  };

  export const Form = {
    GET_ALL: "api/data/form/all",
    SEARCH: "api/data/form/search",
    GET_BY_ID: "api/data/form/{id}",
    GET_ALL_STEPS: "api/data/form/steps",
  };

  export const Flight = {
    PATH: "api/data/flight-info",
  };

  export const File = {
    UPLOAD: "api/file/upload",
    GET_URL: "api/file/pre-signed-url",
  };

  export const Role = {
    PERMISSION_ALL: "api/admin/auth/permission/all",
    ROLE_ALL: "api/admin/auth/role/all",
    CREATE_ROLE: "api/admin/auth/role/create",
    UPDATE_ROLE: "api/admin/auth/role/update/{id}",
    DELETE_ROLE: "api/admin/auth/role/delete/{id}",
    USER_ALL: "api/admin/auth/user/all",
    USER_BY_ID: "api/admin/auth/user/get/{id}",
    UPDATE_USER_ROLE: "api/admin/auth/user/update-role/{id}",
  }
}
